import { Component, Input } from '@angular/core';
import { FilterBase } from 'src/app/shared/grid/filter-base';
import { GridTextFilterComponent } from './grid-text-filter.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { GRID_MATERIAL_PROVIDERS } from 'src/app/shared/grid/grid-material-control-defaults.const';

@Component({
    selector: 'grid-number-filter',
    template: `<mat-form-field class="text-field-input">
        <input
            matInput
            [autocomplete]="'3453'"
            [(ngModel)]="value"
            type="number"
            [placeholder]="title"
            [min]="allowNegative ? minInteger : 0"
            (focusin)="onFocusIn()"
            (focusout)="onFocusOut()"
            (keypress)="onKeyPress($event)" />
    </mat-form-field>`,
    providers: [...GRID_MATERIAL_PROVIDERS, { provide: FilterBase, useExisting: GridNumberFilterComponent }],
    standalone: true,
    imports: [MatFormFieldModule, FormsModule, MatInputModule]
})
export class GridNumberFilterComponent extends GridTextFilterComponent {
    minInteger = Number.MIN_SAFE_INTEGER;
    @Input() allowNegative = true;

    onKeyPress(e: KeyboardEvent): boolean {
        super.onKeyPress(e);

        if (this.allowNegative) {
            return true;
        }

        return (e.key >= '0' && e.key <= '9') || e.key === '.';
    }

    onValueChange(value: number) {
        this.trimFilterByField(this.filter, this.field);
        this.updateFilter({
            field: this.field,
            operator: 'eq',
            value: value
        });

        this.filterValueChanged.emit(this.filter);
    }
}
